import router from '@/router';
import { ServicesContainer } from '@/services';
import { AnalyticsEventType, WebPageDetails } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { MUTATIONS } from '@/store/adobe';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';
import { ExternalLinkReferrer, EmptyLinkInteraction } from '../constants';

export class AdobePageLoadEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.PageLoaded;

  constructor(store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    const currentOrder = services.order.getCurrentOrder();
    
    Object.assign(this.web.webPageDetails, {
      siteRegion: store.state.ui.countryProfile.countryCode || '' ,
      language: window.navigator.language.toLowerCase(),
      URL: window.location.origin + router.currentRoute.fullPath,
    } as WebPageDetails);

    const storedEvent = store.state.adobe.linkClickedEvent;

    if (storedEvent === null) {
      // when there is no storeEvent, check referrer
      // if there is no referrer or the referrer's
      // domain is the same as the current domain
      // set WebInteraction to 'not-set'
      // else set WebInteraction to 'external'
      if(!document.referrer || document.referrer.split('/')[2].includes(document.location.host)) {
        this.web.webInteraction = EmptyLinkInteraction;
      }
      else {
        this.web.webInteraction = ExternalLinkReferrer;
      }
    } else {
      this.web.webInteraction = storedEvent;
      // remove linkClickedEvent from store after it is used
      services.analytics.removeLinkClickedEventFromStore();
    }

    if (store.state.adobe.registrationCompleteEvent) {
      this.account.registrationComplete = store.state.adobe.registrationCompleteEvent;
      // remove registrationCompleteEvent from store after it is used
      services.analytics.removeRegistrationCompleteEventFromStore();
    }
    if (store.state.adobe.rewardsEnrollEvent) {
      this.account.rewardsEnroll = store.state.adobe.rewardsEnrollEvent;
      // remove rewardsEnrollEvent from store after it is used
      services.analytics.removeRewardsEnrollEventFromStore();
    }

    if(!store.state.adobe.haveInitialPropertiesBeenSent) {
      store.commit(MUTATIONS.SET_INITIAL_APP_LOAD_PROPERTIES_HAVE_BEEN_SENT, true);
    }

    if (store.state.adobe.addToBagEvent) {
      Object.assign(this.commerce, store.state.adobe.addToBagEvent.commerce);
      this.productListItems = store.state.adobe.addToBagEvent.productListItems;

      if (!currentOrder?.order.meals || currentOrder?.order.meals.length <= 1) {
        this.event = AnalyticsEventType.OpenBag;
        Object.assign(this.commerce, { productListOpens: { value: 1 }, productListViews: { value: 1 } });
      } else {
        this.event = AnalyticsEventType.AddToBag;
      }
      services.analytics.removeAddToBagEventFromStore();
    }

    if (store.state.adobe.bagViewEvent) {
      this.event = AnalyticsEventType.ViewBag;
      Object.assign(this.commerce, store.state.adobe.bagViewEvent.commerce);
      this.productListItems = store.state.adobe.bagViewEvent.productListItems;
      services.analytics.removeBagViewEventFromStore();
    }

    if (store.state.adobe.upsellImpression) {
      this.productListItems = [...(this.productListItems || []), ...store.state.adobe.upsellImpression];
      this.commerce.upsellImpression = { value: 1 };
      services.analytics.removeUpsellImpressionFromStore();
    }
  }
}
